// extracted by mini-css-extract-plugin
module.exports = {"about":"styles_about__8KcWq","about__header":"styles_about__header__uAQTU","about__text":"styles_about__text__SSz0S"};